import { render, staticRenderFns } from "./StopPD_Items.vue?vue&type=template&id=5327bc21"
import script from "./StopPD_Items.vue?vue&type=script&lang=js"
export * from "./StopPD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports